/* eslint-disable @typescript-eslint/no-unused-vars */
import './MapLeaflet.css';
import { AppContext } from '../../state/AppContextProvider';

import { useContext, useEffect } from 'react';
import { WP_Place } from '../../model/map/map';
import { Filter } from '../filters/Filter';
import { MarkerModal } from './MarkerModal';
import { useLogger } from '../../services/LogService';
import { useLeafLet } from '../../hooks/LeafletHooks';
import { useFilterParents } from '../../hooks/FilterHooks';
import { IonIcon } from '@ionic/react';
import { optionsOutline } from 'ionicons/icons';

export const MapLeaflet: React.FC<any> = ({ tagId }) => {
  const logger = useLogger('MapPage');

  const { state } = useContext(AppContext);

  const {
    initMap,
    mapIsInit,
    resetView,
    createMarkers,
    setPlaces,
    initialPlacesList,
    placesList,
    currentSelectedPlace,
    setMarkerSelected,
    isMarkerSelected,
  } = useLeafLet(state.placeTags, tagId);

  useEffect(() => {
    // Need to check if animPlash is done before init map, create an issue where we don't see the map
    if (!state.showAnimSplash) {
      initMap();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.showAnimSplash]);

  // Add Markers
  useEffect(() => {
    if (placesList.length > 0) {
      mapIsInit && createMarkers();
    }

    // When returning to global map, reset filter and view and close modal
    if (tagId === undefined && mapIsInit) {
      setMarkerSelected(false);
      resetView();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [placesList, tagId]);

  const onChange = (selectedSubTags) => {
    logger.info('Applying filters');

    // We check if the tag ID is not already in this array, making sure we don't have duplicate tags
    const listPlaces: number[] = [];
    selectedSubTags.forEach((tags) => {
      tags.tags.forEach((tag) => {
        if (listPlaces.indexOf(tag.id) === -1) {
          listPlaces.push(tag.id);
        }
      });
    });

    if (listPlaces.length === 0) {
      setPlaces(initialPlacesList);
    } else {
      const filteredList: WP_Place[] = [];
      initialPlacesList.forEach((place) => {
        if (listPlaces.indexOf(place.id) !== -1) {
          const placeClone = JSON.parse(JSON.stringify(place));
          filteredList.push(placeClone);
        }
      });
      setPlaces(filteredList);
    }
  };

  const onResetFilter = () => {
    logger.info('Reseting filters');
    setPlaces(initialPlacesList);
    onReset();
  };

  const {
    selectParentTag,
    setSelectedParentTag,
    selectedParentTagId,
    childrenTags,
    selectSubTag,
    isSubTagSelected,
    selectedSubTags,
    setAllSelected,
    isFiltered,
    onReset,
    showModal,
    openModal,
  } = useFilterParents(state.placeTags, onChange, true);

  const isFilter = isFiltered();

  return (
    <>
      <div id="leaflet-map" className="h-full"></div>
      <div className="absolute right-0 bottom-0 z-[99999] mr-4 md:mr-14 mb-6 md:mb-[5.5rem]">
        <Filter
          className="map"
          multipleSelect={true}
          categories={state.placeTags}
          selectParentTag={selectParentTag}
          setSelectedParentTag={setSelectedParentTag}
          selectedParentTagId={selectedParentTagId}
          childrenTags={childrenTags}
          selectSubTag={selectSubTag}
          isSubTagSelected={isSubTagSelected}
          selectedSubTags={selectedSubTags}
          setAllSelected={setAllSelected}
          onResetFilter={onResetFilter}
          isFiltered={isFiltered}
          backUrl={'/pages/map'}
          showModal={showModal}
          openModal={openModal}
        ></Filter>
        <div className="relative bg-primary w-12 h-12 rounded-3xl px-2 py-2 flex justify-center items-center">
          <button
            className="flex justify-center items-center"
            onClick={() => openModal(true)}
          >
            <IonIcon
              icon={optionsOutline}
              className="w-6 h-6 text-white -rotate-90"
            />
            {isFilter && (
              <div className="absolute flex items-center justify-center bottom-0 right-0 bg-black rounded-full w-5 h-5 ">
                <svg
                  width="8"
                  height="8"
                  viewBox="0 0 8 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 1L2.97547 6.74847C2.92237 6.82476 2.8519 6.88735 2.76986 6.93107C2.68782 6.97478 2.59657 6.99838 2.50363 6.99992C2.41068 7.00146 2.3187 6.98089 2.23526 6.9399C2.15183 6.89892 2.07933 6.8387 2.02373 6.7642L1 5.39954"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            )}
          </button>
        </div>
      </div>
      {currentSelectedPlace && (
        <MarkerModal
          showModal={isMarkerSelected}
          setShowModal={setMarkerSelected}
          currentSelectedPlace={currentSelectedPlace}
        />
      )}
    </>
  );
};
